module.exports = __webpack_public_path__ + "img/tg_photo2.958b9abc.png";